import '/@front:css/hbm.css'

import RegistrationForm from '/@front:shared/components/scheg/RegistrationForm.vue'
import { mountPage } from '/@front:shared/mount-page'

mountPage(
  {
    name: 'HbmForm',
    components: {
      'registration-form': RegistrationForm,
    },
  },
  { telInput: true, el: '#hbm-app' },
)
